import { useEffect, useState } from "react";
import { brand } from "../config/brand";
import { fetchHealth, fetchReadiness, getApiBaseUrl } from "../lib/api";
import { formatUptime } from "../lib/format";
import { healthTone, liveTone } from "../lib/status";
import { StatusPill } from "../components/StatusPill";

export function StatusPage({ onNavigate }: { onNavigate: (path: string) => void }) {
  const [rows, setRows] = useState<
    { name: string; detail: string; tone: ReturnType<typeof healthTone> }[]
  >([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const [h, r] = await Promise.all([fetchHealth(), fetchReadiness()]);
      if (cancelled) return;
      setRows([
        {
          name: "API Health",
          detail: h.ok
            ? `${h.data?.status} · mode ${h.data?.mode ?? "—"}`
            : h.error ?? "unreachable",
          tone: healthTone(h.data?.status, h.ok),
        },
        {
          name: "Readiness",
          detail: r.ok
            ? `${r.data?.status} · ${r.data?.storageMode ?? "—"} · up ${formatUptime(r.data?.uptimeSeconds)}`
            : r.error ?? "unreachable",
          tone: healthTone(r.data?.status, r.ok),
        },
        {
          name: "Live execution",
          detail: h.data?.liveExecutionEnabled ? "ENABLED" : "Disabled",
          tone: liveTone(Boolean(h.data?.liveExecutionEnabled)),
        },
      ]);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="login-shell">
      <div className="login-card" style={{ width: "min(560px, 100%)" }}>
        <h1>{brand.productName} status</h1>
        <p className="subtitle">Public probes only · {getApiBaseUrl()}</p>
        <div className="content-stack">
          {rows.map((row) => (
            <div
              key={row.name}
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: 12,
                alignItems: "center",
                padding: "12px 0",
                borderBottom: "1px solid var(--border-subtle)",
              }}
            >
              <div>
                <strong>{row.name}</strong>
                <div style={{ color: "var(--text-secondary)", fontSize: 12, marginTop: 4 }}>{row.detail}</div>
              </div>
              <StatusPill label={row.tone === "ok" ? "Operational" : row.tone === "critical" ? "Degraded" : "Check"} tone={row.tone} />
            </div>
          ))}
        </div>
        <button type="button" className="btn" onClick={() => onNavigate("/dashboard/overview")}>
          Open operations console
        </button>
      </div>
    </div>
  );
}
